export const NEW = 'new';
export const APPROVED = 'approved';
export const CANCELLED = 'cancelled';

export default Object.freeze({
  NEW,
  APPROVED,
  CANCELLED
});
